// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tj-2";
export var container = "_tj-4";
export var dismissButton = "_tj-3";
export var hasPaddingBottom = "_tj-6";
export var last = "_tj-e";
export var scrollbarThumb = "_tj-c";
export var scrollbarTrack = "_tj-b";
export var selected = "_tj-9";
export var spin = "_tj-1";
export var spinning = "_tj-0";
export var suggestionItem = "_tj-d";
export var suggestionsPanel = "_tj-5";
export var tonePill = "_tj-8";
export var tonesContainer = "_tj-7";
export var unselected = "_tj-a";